<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
       />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import AcademicYearServices from '@/services/api/academicyear.api'
import LocationServices from '@/services/api/location.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@//modules/report/document'

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => 
  ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'PEI en Controversia',
      routes: ["Informes", "PEI en Controversia"]
    },
    model: {
      search: {
        collections: {
          academicYears: [],
          centers: [],
          municipalities: [],
          schools: [],
        },
        filters: {
          academicYear: null,
          center: null,
          centerDisabled: true,
          municipality: null,
          municipalityDisabled: true,
          school: null,
          schoolDisabled: true,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
    return [
      {
        name: 'academicYear',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Año Académico',
        placeholder: 'Seleccionar',
        error: "Favor seleccionar un año académico.",
        validations: "required",
        class: 'col-md-3',
        options: this.model.search.collections.academicYears,
        value: this.model.search.filters.academicYear,
        onChanged: this.onChangedAcademicYears,
      },
      {
        name: 'center',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'CSEE',
        placeholder: 'Seleccionar',
        class: 'col-md-3',
        options: this.model.search.collections.centers,
        value: this.model.search.filters.center,
        onChanged: this.onChangedCenter,
        disabled: this.model.search.filters.centerDisabled,
      },
      {
        name: 'municipality',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Municipio',
        placeholder: 'Seleccionar',
        class: 'col-md-3',
        options: this.model.search.collections.municipalities,
        value: this.model.search.filters.municipality,
        onChanged: this.onChangedMunicipality,
        disabled: this.model.search.filters.municipalityDisabled,
      },
      {
        name: 'school',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Escuela',
        placeholder: 'Seleccionar',
        class: 'col-md-3',
        options: this.model.search.collections.schools,
        value: this.model.search.filters.school,
        onChanged: this.onChangedSchool,
        disabled: this.model.search.filters.schoolDisabled,
      },
    ]},
  },
  async mounted() {
    await this.setFilters();
  },
  methods: {
    async setFilters() {
      await AcademicYearServices.getExistingPeisAcademicYears()
        .then(res => this.model.search.collections.academicYears = res.data);
    },
    async onChangedAcademicYears() {
      this.clearCenters();
      this.clearMunicipalities();
      this.clearSchools();

      if (!this.model.search.filters.academicYear) {
        this.disabledDrops(true);
        return false;
      }

      await this.getCenters();
      await this.getMunicipalities();
      await this.getSchools();
     
      this.disabledDrops(false);
    },
    async onChangedCenter() {
      this.clearMunicipalities();
      this.clearSchools();

      await this.getMunicipalities();
      await this.getSchools();
    },
    async onChangedMunicipality() {
      this.clearSchools();
      
      await this.getSchools();
    },
    async getCenters() {
      await LocationServices.getCenters({
        academicYearId: this.model.search.filters.academicYear.id,
      })
      .then(res => this.model.search.collections.centers = res.data);
    },
    async getMunicipalities() {
      await LocationServices.getMunicipalities({
        academicYearId: this.model.search.filters.academicYear.id,
        centerId: this.model.search.filters.center?.id,
      })
      .then(res => this.model.search.collections.municipalities = res.data);
    },
    async getSchools() {
      await LocationServices.getSchools({
        academicYearId: this.model.search.filters.academicYear.id,
        municipalityId: this.model.search.filters.municipality?.id,
        centerId: this.model.search.filters.center?.id,
      })
      .then(res => this.model.search.collections.schools = res.data);
    },
    disabledDrops(disabled) {
      this.model.search.filters.centerDisabled = disabled;
      this.model.search.filters.municipalityDisabled = disabled;
      this.model.search.filters.schoolDisabled = disabled;
    },
    clearCenters() {
      this.model.search.filters.center = null;
    },
    clearMunicipalities() {
      this.model.search.filters.municipality = null;
    },
    clearSchools() {
      this.model.search.filters.school = null;
    },
    async onHandlerSearch() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate();

      if (isValid) {
        this.process();
      }
    },
    async process() {
      await ReportServices.getReport('peiInControversy', {
        academicYearId: this.model.search.filters.academicYear.id,
        centerId: this.model.search.filters.center?.id,
        municipalityId: this.model.search.filters.municipality?.id,
        schoolId: this.model.search.filters.school?.id,
      })
      .then(res => DocumentServices.Download(res.data));
    },
  },
}
</script>